"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dateFns = require("date-fns");
var formatDate = function formatDate(date, options) {
  var composition = options === null || options === void 0 ? void 0 : options.composition;
  var dateStructure = composition || 'd MMM';
  return date ? (0, _dateFns.format)((0, _dateFns.parseISO)(date), dateStructure) : null;
};
var _default = exports["default"] = formatDate;
module.exports = exports.default;